import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  level_names: [
    "Associate", "Senior Associate", "Assistant Manager", "Manager", "Senior Manager",
    "Assistant Vice President", "Vice President", "Senior Vice President", "Director", "Managing Partner",
  ],
  percentages: [10, 5, 4, 3, 3, 2, 1, 1, 1, 1],
  partner_label: "Financial Consultant",
};

const SettingsContext = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/team");
      setSettings(data);
    } catch {
      setSettings(DEFAULTS);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ ...settings, refresh: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
